module.exports = __webpack_public_path__ + "img/bitcoin-bg.bd4f6b31.svg";